import { getTextClassName } from '@nautilusbio/nb-design-system';
import { Dialog } from '@nautilusbio/nb-design-system/Dialog';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Maximize2 } from 'lucide-react';
import React, { type FC, type ReactNode } from 'react';

import styles from '../styles.module.css';

interface DescriptionModalProps {
  title: string;
  canEdit: boolean;
  body: string;
  children?: ReactNode;
  buttonClassName?: string;
}

/**
 * Fullscreen modal for viewing or editing the description.
 * If canEdit is true, children should be the edit form.
 * Otherwise, shows the full description.
 */
const DescriptionModal: FC<DescriptionModalProps> = ({ title, canEdit, body, children, buttonClassName }) => (
  <Dialog
    content={
      <Stack gap={4} orientation="vertical" className={styles.fullscreenModalContent}>
        <Text as="h2" className={styles.modalTitle}>
          {title}
        </Text>
        {canEdit ? children : <pre className={styles.bodyFullscreen}>{body}</pre>}
      </Stack>
    }
    data-testid="fullscreen-description-dialog"
    fullScreen
    title={`${title} - Full View`}
    triggerProps={{
      children: (
        <Stack fullWidth gap={2} orientation="horizontal">
          <Maximize2 size={16} />
          <Text className={getTextClassName('xs')} as="span">
            View Fullscreen
          </Text>
        </Stack>
      ),
      'aria-label': 'View fullscreen',
      className: buttonClassName,
      size: 'xs',
      visual: 'default',
    }}
  />
);

export default DescriptionModal;
